import vue from 'vue';
import VueI18n from 'vue-i18n';
import axios from 'axios';

vue.use(VueI18n);

export const I18n = new VueI18n({
  fallbackLocale: 'en_US',
  silentTranslationWarn: true,
});

window.VueI18n = I18n;
const loadedLanguages = [];

function setI18nLanguage(lang) {
  // Change locale language for vue-i18n
  I18n.locale = lang;
  // Setting HTTP header for natural language and locale
  axios.defaults.headers.common['Accept-Language'] = lang;
  // Set 'lang' attribute on webpage's html tag
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

// function for Lazy loading or asynchronously loading the translation files
export async function loadLanguageAsync(lang) {
  // Error handling for if window.ACC.languageISO is null
  if (!lang) {
    return console.error('ERROR: Window.ACC.languageISO value not set. Translations for page unable to load.');
  }
  // If invoked for the same language as I18n locale
  if (I18n.locale === lang) {
    return Promise.resolve(setI18nLanguage(lang));
  }
  // If the language was already loaded
  if (loadedLanguages.includes(lang)) {
    return Promise.resolve(setI18nLanguage(lang));
  }

  /* Due to race conditions that can arise because of the timing of language translations loading, this tiny-emitter NPM package provides a custom event that will fire once all translations are completed. 
  
    * Listen to the 'langs-loaded' event as a hook to request translations, only once we are sure that they have finished loading. The initial need was for custom error messages for login/password form validation, but tiny-emitter is now available for other race condition scenarios. 
  
    * Refer to instances of emitter.on('langs-loaded', function () {} for usage examples.
    */
  const Emitter = require('tiny-emitter');
  const emitter = new Emitter();
  emitter.emit('langs-loaded', true);

  // If the language hasn't been loaded yet
  return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.json`).then((messages) => {
    I18n.setLocaleMessage(lang, messages.default);
    loadedLanguages.push(lang);
    return setI18nLanguage(lang);
  });
}

export default I18n;
